import { DateTime } from "luxon";
import styles from "./Documents.module.scss";
import DownloadInvoiceButton from "../../components/DownloadInvoiceButton/DownloadInvoiceButton"
import { IParkingSession } from "../../types/vehiclePicker.type";
import { getParkingType, getParkingTypeIcon } from "../../utils/getParkingType";
import { ParkingType } from "../../types/parkingType.type";
import { useTranslation } from "react-i18next";

type Props = {
	session: IParkingSession;
}

const ParkingSessionDocument: React.FC<Props> = ({
	session
}) => {
	const { t } = useTranslation();

	const parkingType = getParkingType(session.ticket);
	const icon = getParkingTypeIcon(parkingType)

	const formatIsoTimeSpan = (from: string, to: string) => {
		const fromDate = DateTime.fromISO(from);
		const toDate = DateTime.fromISO(to);
		
		const fromFormatted = fromDate.toFormat("dd. MM. yyyy HH:mm");
		let toFormatted;

		if (fromDate.day == toDate.day) {
			toFormatted = DateTime.fromISO(to).toFormat("HH:mm");
		}
		else {
			toFormatted = toDate.toFormat("dd. MM. yyyy HH:mm");
		}

		return `${fromFormatted} - ${toFormatted}`;
	}

	const getSectionCode = () => {
		switch (parkingType) {
			case ParkingType.ParkingZone:
				return session.ticket.sectionCode;
			case ParkingType.ParkingMachine:
			case ParkingType.InfoBox:
				return session.ticket.parkMachineCode;	
		}
	}
	console.log(session.ticket.priceTotal);
	return (
		<div className={styles.item}>
			<div className={styles.icon}>
				<img alt={parkingType} src={icon} />
			</div>
			<div className={styles.info}>
				<div className={styles.title}>
					<div className={styles.itemTitle}>
						{formatIsoTimeSpan(session.from, session.to)}
					</div>
				</div>
				<div className={`${styles.sessionInfo} ${styles.textMuted}`}>
					<div className={styles.licensePlate}>
						{`${session.ticket.licensePlate}`}
					</div>
					<div>
						-
					</div>
					<div>
						{getSectionCode()}
					</div>
				</div>
				<div className={styles.price}>
					{`${t("documents.price")} ${session.ticket.priceTotal} ${t("global.currency.czk")}`}
				</div>					
			</div>
			<div className={styles.downloadInvoiceWrapper}>
				<DownloadInvoiceButton
					ticketGUID={session.ticket.ticketGUID}
				/>
			</div>
		</div>
	)
}

export default ParkingSessionDocument;
